module.exports = __webpack_public_path__ + "fonts/check_svgrepo.com.svg";